import React, { useContext, useEffect, useState } from "react";
import logo from "assets/images/logo.jpg";
import miniLogo from "assets/images/favicon.ico";
import { NavLink } from "react-router-dom";
import { Button } from "antd";
import BurgerMenu from "./BurgerMenu";
import { GiHamburgerMenu } from "react-icons/gi";
function Header() {
  const [showBurgerMenu, setShowBurgerMenu] = useState(false);
   const handleClickBurgerMenu = (e) => {
     e.preventDefault();
     setShowBurgerMenu((prev) => !prev);
   };
  return (
    <>
      <div className="fixed inset-x-0 h-[60px] bg-primary2 top-0 flex items-center px-7 py-2 z-50 transition-all">
        {/* Logo */}
        <NavLink to={"/"} className="flex-shrink-0">
          <img src={logo} style={{ height: 40 }} className="hidden md:block" />
          <img
            src={miniLogo}
            style={{ height: 40 }}
            className="block md:hidden"
          />
        </NavLink>

        {/* Title - Expands to push button right */}
        <div className="md:text-2xl font-bold text-[#5c1090] flex-grow text-center">
          {/* Томүжин Алтернатив сургуулийн 2025 оны элсэлт */}
        </div>

        {/* Right-aligned button */}
        <div className="flex-shrink-0 hidden md:block">
          <Button
            type="primary"
            onClick={() => {
              window.open("https://portal.tomujin.edu.mn", "_blank");
            }}
          >
         Портал руу нэвтрэх
          </Button>
        </div>
        <div className="block md:hidden">
          <button
            className="p-2 transition-all border border-transparent rounded-full text-primary hover:border-primary"
            onClick={handleClickBurgerMenu}
          >
            <GiHamburgerMenu size={24} />
          </button>
        </div>
        <BurgerMenu showMenu={showBurgerMenu} onClose={handleClickBurgerMenu}>
          <div className="flex flex-col divide-y">
            <NavLink
              to={"https://portal.tomujin.edu.mn"}
              onClick={() => setShowBurgerMenu(false)}
              className={({ isActive }) =>
                `menu-item px-7 py-2 transition-all rounded ${
                  isActive ? "bg-primary text-primary2" : ""
                }`
              }
            >
              Tomujin Portal
            </NavLink>

            {/* <button
              className="flex items-center gap-2 py-2 text-red-400 px-7"
              onClick={() => action.logout()}
            >
              <FiLogOut size={18} /> ГАРАХ
            </button> */}
          </div>
        </BurgerMenu>
      </div>
    </>
  );
}

export default Header;
